import type { ReactElement } from "react";

import { BasicModal } from "@similarweb/ui-components";

type ApplyTopicModalProps = {
    children: ReactElement;
    customStyle: Record<string, any>;
    isOpen: boolean;
    showCloseIcon?: boolean;
    onClose?: () => void;
};
const ApplyTopicModal = ({
    isOpen,
    children,
    customStyle,
    showCloseIcon = false,
    onClose,
}: ApplyTopicModalProps) => {
    return (
        <BasicModal
            isOpen={isOpen}
            closeIconConfig={{
                show: showCloseIcon,
                onClick: onClose,
            }}
            customStyles={customStyle}
        >
            {children}
        </BasicModal>
    );
};

export default ApplyTopicModal;
